var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStepAfter = function SvgStepAfter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "27CE3ABA-05ED-475D-8D79-D0B778396DB5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-437.000000, -721.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-Arrow-/-navigation-left-circle-1-1",
    transform: "translate(437.000000, 721.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.987,12 C23.9852147,11.311277 23.6889726,10.6561961 23.173,10.2 L11.994,0.361 C11.3937848,-0.130344205 10.5122332,-0.0579738559 10.0001871,0.524680634 C9.48814108,1.10733512 9.52961985,1.99087929 10.094,2.523 L18.731,10.123 C18.808544,10.1918032 18.8355799,10.3013257 18.798961,10.3983102 C18.7623421,10.4952947 18.6696667,10.5596174 18.566,10.56 L1.452,10.56 C0.65670996,10.56 0.012,11.20471 0.012,12 C0.012,12.79529 0.65670996,13.44 1.452,13.44 L18.563,13.44 C18.6666027,13.4409967 18.758947,13.5055478 18.7954715,13.6025039 C18.831996,13.6994599 18.8051945,13.8088948 18.728,13.878 L10.091,21.478 C9.67960973,21.8102834 9.48344901,22.3413235 9.58004156,22.8612505 C9.6766341,23.3811775 10.050437,23.8063291 10.5537216,23.9686834 C11.0570061,24.1310376 11.6087879,24.0044697 11.991,23.639 L23.172,13.8 C23.6885551,13.3441422 23.985218,12.6889356 23.987,12 Z",
    id: "icon-fill-color"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStepAfter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/step-after.fbd56c63d5a9ba2af7ed8292c2e00cf9.svg";